import { THUMBNAIL_STATUS_RIBBON_COMPONENT } from './thumbnail-status-ribbon';
import { ThumbnailStatusRibbonSmartsheet } from './thumbnail-status-ribbon-smartsheet';

export const SMAR_THUMBNAIL_STATUS_RIBBON_COMPONENTS = {
  [THUMBNAIL_STATUS_RIBBON_COMPONENT]: ThumbnailStatusRibbonSmartsheet,
};
